"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferIssueSchema = exports.IssueActionSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
const _1 = require(".");
exports.IssueActionSchema = zod_1.z.object({
    type: zod_1.z.nativeEnum(__1.IssueActionType),
    url: __1.LongStringSchema.url().optional(),
    isUrlDynamic: zod_1.z.boolean().optional(),
    name: __1.ShortStringSchema,
});
exports.OfferIssueSchema = __1.BaseSchema.extend({
    type: zod_1.z.nativeEnum(__1.IssueType),
    code: __1.ShortStringSchema,
    summary: __1.ShortStringSchema,
    wasReviewed: zod_1.z.boolean().optional(),
    description: __1.ExtraLongStringSchema,
    channel: __1.ChannelSchema.partial().required({ id: true }),
    /**
     * URL where the user can find help on how to fix the issue.s
     */
    helpUrl: __1.LongStringSchema.url().optional(),
    primaryAction: exports.IssueActionSchema.optional(),
    secondaryAction: exports.IssueActionSchema.optional(),
    relatedAttributes: zod_1.z.array(_1.ItemAttributeSchema).optional(),
    channelIssueCode: __1.ShortStringSchema.optional(),
    channelIssueMessage: __1.LongStringSchema.optional(),
    channelIssueType: __1.ShortStringSchema.optional(),
});
//# sourceMappingURL=offer-issue.js.map